/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from './tooltip';

export class DateInputFloatingRow extends React.Component {
  static initClass() {
    this.propTypes = {
      label: PropTypes.string,
      icon: PropTypes.string,
      tooltip: PropTypes.string,
      tooltipUrl: PropTypes.string,
      placeholder: PropTypes.string,
      type: PropTypes.oneOf(['time', 'date']).isRequired,
      initialValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
      ]),
      onChange: PropTypes.func,
      instanceKey: PropTypes.any,
      required: PropTypes.bool,
      name: PropTypes.string,
      showPreview: PropTypes.bool,
      showError: PropTypes.bool,
      formHasDateError: PropTypes.bool,
      dateError: PropTypes.string
    };

    this.defaultProps = {
      type: 'date',
      initialDateFormat: Slzr.Formats.ShortDate,
      initialTimeFormat: Slzr.Formats.LongTime,
      previewDateFormat: Slzr.Formats.LongDate,
      previewTimeFormat: Slzr.Formats.LongTime,

      dateError: 'Unknown date',
      timeError: '',

      instanceKey: '',

      showPreview: true,
      showError: true,

      formHasDateError: false,

      onChange(event, current_date, input_value) {}
    };
  }

  constructor(props) {
    let date; let show_preview;
    super(props);
    this._inputChanged = this._inputChanged.bind(this);
    this._keyPressed = this._keyPressed.bind(this);
    this._formatPreview = this._formatPreview.bind(this);
    this.renderFormDateError = this.renderFormDateError.bind(this);
    this.render = this.render.bind(this);

    this.id_prefix = _.uniqueId('date-input-');

    let initial_value = null;
    const current_value = this.props.initialValue;
    const is_valid = (show_preview = (this.props.initialValue != null));
    const is_blank = (this.props.initialValue == null);

    if (this.props.type === 'date') {
      if (typeof(this.props.initialValue) === 'string') {
        date = new Date(`${this.props.initialValue}T00:00:00`);
      } else {
        date = this.props.initialValue;
      }
    }

    if (this.props.initialValue != null) {
      initial_value = this.props.type === 'date' ?
        0 === Date.compare(date, Date.today()) ?
          'Today'
        : 0 === Date.compare(date, Date.today().add(1).days()) ?
          'Tomorrow'
        :
          date.toString(this.props.initialDateFormat)
      :
        (date = this.props.initialValue.toString(this.props.initialTimeFormat));
    }

    this.state = {
      isValid: is_valid,
      isBlank: is_blank,
      showPreview: show_preview,
      currentValue: date,
      value: initial_value
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let date; let show_preview;
    if (nextProps.instanceKey === this.props.instanceKey) { return; }

    let initial_value = null;
    const current_value = nextProps.initialValue;
    const is_valid = (show_preview = (nextProps.initialValue != null));
    const is_blank = (nextProps.initialValue == null);

    if (nextProps.type === 'date') {
      if (typeof(nextProps.initialValue) === 'string') {
        date = new Date(`${nextProps.initialValue}T00:00:00`);
      } else {
        date = nextProps.initialValue;
      }
    }

    if (nextProps.initialValue != null) {
      initial_value = nextProps.type === 'date' ?
        0 === Date.compare(date, Date.today()) ?
          'Today'
        : 0 === Date.compare(date, Date.today().add(1).days()) ?
          'Tomorrow'
        :
          date.toString(nextProps.initialDateFormat)
      :
        nextProps.initialValue.toString(nextProps.initialTimeFormat);
    }

    return this.setState({
      isValid: is_valid,
      isBlank: is_blank,
      showPreview: show_preview,
      currentValue: date,
      value: initial_value
    });
  }


  _inputChanged(evt) {
    const input_value = evt.target.value;

    const current_value = (() => {
      if (!input_value || input_value.isBlank()) {
      return 'blank';
    }
      const d = Date.parse(input_value, {bias: 'future_date'});
      if (d instanceof Date) {
        return d;
      }
      return 'error';
    })();

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(evt, current_value, input_value);
    }

    return this.setState({
      isValid: current_value !== 'error',
      isBlank: current_value === 'blank',
      showPreview: current_value !== 'blank',
      currentValue: current_value,
      value: input_value
    });
  }

  _keyPressed(evt) {
    if ((this.props.onEnterKey != null) && (evt.key === 'Enter')) {
      if (this.props.onEnterKey(evt)) { return evt.preventDefault(); }
    }
  }

  _formatPreview(date) {
    if (this.props.type === 'date') {
      switch (date) {
        case 'blank': return '';
        case 'error':
          return this.props.dateError;
        default: return date.toString(this.props.previewDateFormat);
      }
    } else {
      switch (date) {
        case 'blank': return '';
        case 'error': return this.props.timeError;
        default: return (date != null ? date.toString(this.props.previewTimeFormat) : undefined);
      }
    }
  }

  renderFormDateError() {
    if (!this.props.formHasDateError) { return; }

    return <span className="field-error__text" role="alert"><i className="fas fa-info-circle" aria-hidden="true"></i> You need a start date.</span>;
  }

  render() {
    let label_tag;
    const preview_el = (this.state.currentValue === 'error') && this.props.showError ?
      <span id={`${this.id_prefix  }-preview`} role="alert" className="preview error">{this._formatPreview(this.state.currentValue)}</span>
    : (this.state.currentValue !== 'blank') && this.props.showPreview && this.state.showPreview ?
      <span id={`${this.id_prefix  }-preview`} className="preview">{this._formatPreview(this.state.currentValue)}</span>
    :
      null;

    if (this.props.label) {
      let required_tag;
      const tooltip_tag = !_.isBlank(this.props.tooltip) ?
        <Tooltip text={this.props.tooltip}
                  url={this.props.tooltipUrl} /> : undefined;

      if (this.props.required) { required_tag = <span className="required">REQUIRED</span>; }
      label_tag = <label className="em-input-floating--label" htmlFor={this.props.name}>{this.props.label} {required_tag} {tooltip_tag}</label>;
    } else {
      label_tag = null;
    }

    const is_invalid = this.props.formHasDateError || ((this.state.currentValue === 'error') && this.props.showError);

    const classes = classNames('em-input-floating', {
      'em-input-floating--placeholder': this.state.value === '',
      'em-error': is_invalid
    }
    );

    const containerClasses = classNames('em-input_container', {
      'em-input_container--with-error': this.props.formHasDateError
    });

    return <div className={containerClasses}>
      <div className={classes}>
        {label_tag}
        <input type="text" value={this.state.value}
               aria-describedby={`${this.id_prefix  }-preview`}
               aria-invalid={is_invalid}
               name={this.props.name}
               id={this.props.name}
               className="em-input-floating--input"
               onChange={this._inputChanged}
               onKeyDown={this._keyPressed}/>
        {!this.props.formHasDateError && <i className="fas fa-info-circle em-icon-error"></i>}
        {this.props.icon && <i className={this.props.icon}></i>}
      </div>
      {preview_el}
      {this.renderFormDateError()}
    </div>;
  }
}
DateInputFloatingRow.initClass();
